import { useEffect } from "react";
import { useSelector } from "react-redux";
import chroma from "chroma-js";

function ThemeColors() {
  const theme = useSelector((state: any) => state.ui?.theme);

  useEffect(() => {
    const light = theme?.light ?? {};
    const dark = theme?.dark ?? {};

    const cfg = {
      light: {
        primaryColor: light?.["primary-color"] || "#216ff3",
        sidebarBgColor: light?.["sidebar-bg-color"] || "#24263d"
      },
      dark: {
        primaryColor: dark?.["primary-color"] || "#36a1f2",
        sidebarBgColor: dark?.["sidebar-bg-color"] || "#15202c"
      }
    };

    const bgColor = (c: any) => chroma(c).darken(0.4).hex();
    const borderColor = (c: any) => chroma(c).darken(0.6).hex();
    const sidebarActiveBg = (c: any) => chroma(c).brighten(0.5).hex();
    const sidebarHoverBg = (c: any) => chroma(c).brighten(0.3).hex();
    const textColor = (c: any) =>
      chroma.contrast(c, chroma("black")) > 7
        ? chroma("black")
        : chroma("white");

    const css = `
        body[data-theme="light"] {
          --primary-color: ${cfg.light.primaryColor};
          --primary-color-disabled: ${sidebarHoverBg(cfg.light.primaryColor)};
          --btn-primary-bg-color: ${bgColor(cfg.light.primaryColor)};
          --btn-primary-border-color: ${borderColor(cfg.light.primaryColor)};
          --btn-primary-text-color: ${textColor(cfg.light.primaryColor)};
          --sidebar-bg-color: ${cfg.light.sidebarBgColor};
          --sidebar-text-color: ${textColor(cfg.light.sidebarBgColor)};
          --sidebar-header-bg-color: ${cfg.light.sidebarBgColor};
          --sidebar-active-link-bg-color: ${sidebarActiveBg(
            cfg.light.sidebarBgColor
          )};
          --sidebar-link-hover-bg-color: ${sidebarHoverBg(
            cfg.light.sidebarBgColor
          )};
        }
        body[data-theme="dark"] {
          --primary-color: ${cfg.dark.primaryColor};
          --primary-color-disabled: ${sidebarHoverBg(cfg.dark.primaryColor)};
          --btn-primary-bg-color: ${bgColor(cfg.dark.primaryColor)};
          --btn-primary-border-color: ${borderColor(cfg.dark.primaryColor)};
          --btn-primary-text-color: ${textColor(cfg.dark.primaryColor)};
          --sidebar-bg-color: ${cfg.dark.sidebarBgColor};
          --sidebar-text-color: ${textColor(cfg.dark.sidebarBgColor)};
          --sidebar-header-bg-color: ${cfg.dark.sidebarBgColor};
          --sidebar-active-link-bg-color: ${sidebarActiveBg(
            cfg.dark.sidebarBgColor
          )};
          --sidebar-link-hover-bg-color: ${sidebarHoverBg(
            cfg.dark.sidebarBgColor
          )};
        }
      `;

    let el = document.getElementById(
      "mx-theme-colors"
    ) as HTMLStyleElement | null;
    if (!el) {
      el = document.createElement("style");
      el.id = "mx-theme-colors";
      el.setAttribute("type", "text/css");
      document.head.appendChild(el);
    }
    el.textContent = css;
  }, [theme]);

  return null;
}

export { ThemeColors };
